import { render } from "./VPASet2.vue?vue&type=template&id=ecb7f0a0"
import script from "./VPASet2.vue?vue&type=script&lang=js"
export * from "./VPASet2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__